import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson 4: review a draft (score, suggestions, placeholders). Started
 * from the lesson page in a new tab; never auto-started. Runs on the officer's
 * own reports: the first step asks them to open one, so it works whatever is
 * in their list.
 */
const tour: TutorialDefinition = {
  id: "review-the-draft",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Review the draft",
  description: "Read the score, work the suggestions, and clear the placeholders.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "review-the-draft",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report",
      content: "Click any report that has a draft. A report you just generated works best.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: sel("reportScore"),
      waitFor: sel("reportScore"),
      waitTimeoutMs: 10000,
      title: "The score",
      content:
        "How complete and clear the report is, not how long it is. Labels run from Outstanding down to Unsatisfactory.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("suggestionItem"),
      waitFor: sel("suggestionItem"),
      title: "Suggestions",
      content:
        "Each one is a gap a supervisor would ask about. Check it off when you have handled it. Click into the narrative to type a fix, then use Re-evaluate to rescore.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("addToReportButton"),
      waitFor: sel("addToReportButton"),
      title: "Address Suggestions",
      content:
        "For several gaps at once, record or upload audio here. The AI writes your answers into the right places and you review each change.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("reEvaluate"),
      waitFor: sel("reEvaluate"),
      title: "Re-evaluate",
      content: "After your edits, click Re-evaluate to refresh the score and the list.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("editorNarrative"),
      waitFor: sel("editorNarrative"),
      title: "Placeholders",
      content:
        "Bracketed, highlighted text is a fact the recording never gave. Click it and type the real value. An exported report still contains any placeholder you leave in it.",
      disableBeacon: true,
      placement: "right",
    },
  ],
};

export default tour;
